// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import parse from 'html-react-parser';
import { createSyllabus, getGroups, getSyllabus, updateSyllabus, getSyllabusById, fetchCSRF } from "../data/repository";

function Syllabus(props) {

    const [groups, setGroupsData] = useState([]);
    const [syllabusMap, setSyllabusMap] = useState({});
    const [csrfToken, setCsrfToken] = useState(null);

    // var API_HOST = 'http://localhost:4000';
    var API_HOST = 'https://masrooracademyvic.com.au';

    useEffect(() => {

        // Loads User Details from DB
        async function loadGroupDetails() {
            const currentGroups = await getGroups();
            const studentGroups = currentGroups.filter(groups =>
                groups.group !== 'Male Teacher' &&
                groups.group !== 'Female Teacher' &&
                groups.group !== 'Admin' &&
                groups.group !== 'Principal' &&
                groups.group !== 'Vice Principal' &&
                groups.group !== 'Admin Staff'
            );
            setGroupsData(studentGroups)
        }

        // Loads Syllabus Details from DB
        async function loadSyllabusDetails() {
            const currentSyllabus = await getSyllabus();
            const syllabusData = {};
            currentSyllabus.forEach((syllabus) => {
                syllabusData[syllabus.groupId] = syllabus.syllabusContent;
            });
            setSyllabusMap(syllabusData);
        }

        // Calls the functions above
        loadGroupDetails();
        loadSyllabusDetails();

    }, []);

    if (!csrfToken) {
        fetchCSRF().then(setCsrfToken); // no useEffect
    }

    if (!csrfToken) {
        return <p className="text-center">Loading syllabus editor...</p>; // wait for token
    }

    const editorConfig = {
        simpleUpload: {
            uploadUrl: `${API_HOST}/MAApi/image/upload`,
            withCredentials: true,
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        },
        mediaEmbed: {
            previewsInData: true
        }
    }

    const saveSyllabusContent = async (groupId, content) => {
        // Check if syllabus content already exists for the group in the database
        const existingSyllabus = await getSyllabusById(groupId);

        if (existingSyllabus) {
            // If syllabus content exists, update it in the database
            await updateSyllabus(groupId, content);
        } else {
            // If syllabus content doesn't exist, create it in the database
            await createSyllabus(groupId, content);
        }
    };

    const handleInputChange = (event, editor, groupId) => {
        const data = editor.getData();
        setSyllabusMap((prevSyllabusMap) => ({
            ...prevSyllabusMap,
            [groupId]: data,
        }));

        // Save the syllabus content to the database
        saveSyllabusContent(groupId, data);
    };


    return (
        <div>
            <p>&nbsp;</p>

            {((props.user.group === "Admin") || (props.user.group === "Principal" && props.user.gender === "Male") || (props.user.group === "Vice Principal" && props.user.gender === "Male")) &&
                <>
                    <h3 className="text-center">Add Syllabus:</h3>
                    <br/>
                    {groups.map((group) => (
                        <div key={group.id}>
                            <h4 className="text-center">{group.group}:</h4>
                            <div className="richTextEditor">
                                <h3>{group.name}</h3>
                                <CKEditor
                                    editor={Editor}
                                    data={syllabusMap[group.id] || ""}
                                    onChange={(event, editor) => handleInputChange(event, editor, group.id)}
                                    config={editorConfig}
                                />
                            </div>
                        </div>
                    ))}

                    <p>&nbsp;</p>
                </>
            }

            <div className="col-lg-6 mb-4" style={{ display: "block", margin: "auto" }}>
                <div className="text-center">

                    <div className="card">
                        <h5 className="card-header card text-white bg-custom">Syllabus:</h5>
                        {(props.user.group !== "Male Teacher" && props.user.group !== "Female Teacher" && props.user.group !== "Admin" && props.user.group !== "Principal" && props.user.group !== "Vice Principal" && props.user.group !== "Admin Staff") &&
                            <h5 className="card-header card" style={{ color: "#112c3f" }}>{props.user.group}</h5>
                        }
                        <div className="card-body">

                            {groups.map((group) => (
                                <div key={group.id}>
                                    {props.user.group === group.group && (
                                        <pre className="" style={{ whiteSpace: 'pre-wrap', marginBottom: 0, fontSize: "16px", fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif' }}>
                                            {typeof syllabusMap[group.id] === 'string' ? parse(syllabusMap[group.id]) : ""}
                                        </pre>
                                    )}
                                </div>
                            ))}

                            {(props.user.group === "Male Teacher" || props.user.group === "Female Teacher" || props.user.group === "Admin" || props.user.group === "Principal" || props.user.group === "Vice Principal" || props.user.group === "Admin Staff") &&
                                groups.map((group) => (
                                    <div key={group.id}>

                                        <pre className="" style={{ whiteSpace: 'pre-wrap', marginBottom: 0, fontSize: "16px", fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif' }}>
                                            <h5 style={{ color: "blueviolet" }}>{group.group}:</h5>
                                            {typeof syllabusMap[group.id] === 'string' ? parse(syllabusMap[group.id]) : ""}
                                            <hr style={{ border: '1px dashed' }}></hr>
                                        </pre>

                                    </div>
                                ))
                            }

                        </div>
                    </div>
                </div>
            </div>
            <p>&nbsp;</p>
        </div>


    );
}

// Export the Syllabus Function
export default Syllabus;



